import api from '../api'

export const postProperty = (params) => api.post('/farms/properties', params)

export const putProperty = (params) => api.put(`/farms/properties/${ params.id }`, params)

export const inactivateProperty = (params) => api.patch(`/farms/properties/${ params.id }/active-inactive`)

export const postPropertyPlot = (params) => api.post('/farms/plots/properties', params)

export const putPropertyPlot = (params) => api.put(`/farms/plots/properties/${ params.id }`, params)

export const deletePropertyPlot = (params) => api.delete(`/farms/plots/properties/${ params.id }`)

export const postPropertyMap = (params) => api.post('/farms/properties/maps', params)

export const putPropertyMap = (params) => api.put(`/farms/properties/maps/${ params.id }`, params)

export const deletePropertyMap = (params) => api.delete(`/farms/properties/maps/${ params.id }`)

export const postHarvest = (params) => api.post('/farms/harvests/properties', params)

export const putHarvest = (params) => api.put(`/farms/harvests/properties/${ params.id }`, params)

export const deleteHarvest = (params) => api.delete(`/farms/harvests/properties/${ params.id }`)

export const setCurrentPropertyDefault = (params) => api.patch(`/farms/properties/${ params.id }/change-default`)
